export const getImageProxy = (basePath: string, AppImagesPaths: Record<string, string>) => new Proxy(AppImagesPaths, {
  get(target, property, receiver) {
    return `${basePath}/${AppImagesPaths[property as string]}`;
  }
});

// The customer GUIDs allowed to sign in to an admin app. Historically this was two fixed slots
// (REACT_APP_AUTHORIZATION_ID and REACT_APP_AUTHORIZATION_SECONDARY_ID), which capped the number
// of tenants that could ever be granted access at two. REACT_APP_AUTHORIZATION_IDS takes a
// comma-separated list of any length; the two legacy variables are still honoured and merged in,
// so an environment that sets only those keeps working unchanged.
export const authorizedCustomerGuids = (env: Record<string, string | undefined> = process.env) => [
  ...(env.REACT_APP_AUTHORIZATION_IDS || "").split(","),
  env.REACT_APP_AUTHORIZATION_ID,
  env.REACT_APP_AUTHORIZATION_SECONDARY_ID,
]
  .map(value => value?.trim().toLowerCase())
  .filter((value): value is string => Boolean(value));

export const isAuthorizedCustomerGuid = (
  customerGuid: string | null | undefined,
  env: Record<string, string | undefined> = process.env
) => {
  const allowed = authorizedCustomerGuids(env);
  // No allow-list configured at all means "don't lock anyone out over missing configuration" -
  // the same effective behaviour as before, when both unset variables made every comparison
  // against undefined and the check could never pass for anybody.
  if (allowed.length === 0) return true;
  return Boolean(customerGuid) && allowed.includes(customerGuid!.trim().toLowerCase());
};
